// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCES9G-h0RFkrCYmiW7BtxoNE_sMxxyq0Q",
    authDomain: "fishbowl-the-game.firebaseapp.com",
    databaseURL: "https://fishbowl-the-game.firebaseio.com",
    projectId: "fishbowl-the-game",
    storageBucket: "fishbowl-the-game.appspot.com",
    messagingSenderId: "332331317160",
    appId: "1:332331317160:web:5a6a70937e565f014d8f9d",
    measurementId: "G-PQCCY3W0SF"
  },
  zoom: {
    signatureEndpoint: 'https://us-central1-fishbowl-the-game.cloudfunctions.net/zoomSig',
    apiKey: 'asYX4XCPQcS3Xs5U5wKk7Q'
    // meetingNumber = 123456789
    // role = 0
    // leaveUrl = 'http://localhost:4200'
    // userName = 'Angular'
    // userEmail = ''
    // password = 
  },
  // Changelog it5c-2.2: Move App Shell Configs into src/environments/environment.ts
  // https://ionic-5-full-starter-app-docs.ionicthemes.com/changelog 
  appShellConfig: {
    debug: false,
    networkDelay: 500
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


